import { bitmaskToWeekdays, getWeekdayName, weekdaysToBitmask } from '@/utils'
import { ToggleGroup, ToggleGroupItem } from './ui'

interface Props {
  className?: string
  value: number

  disabled?: boolean

  onChange(value: number): void
}

export function WeekdayToggleGroup({
  className,
  value,

  disabled = false,

  onChange,
}: Props) {
  return (
    <ToggleGroup
      className={className}
      value={bitmaskToWeekdays(value)}
      type="multiple"
      variant="outline"
      disabled={disabled}
      onValueChange={values => onChange(weekdaysToBitmask(values))}
    >
      <ToggleGroupItem value="MO">{getWeekdayName(0, 'md')}</ToggleGroupItem>

      <ToggleGroupItem value="TU">{getWeekdayName(1, 'md')}</ToggleGroupItem>

      <ToggleGroupItem value="WE">{getWeekdayName(2, 'md')}</ToggleGroupItem>

      <ToggleGroupItem value="TH">{getWeekdayName(3, 'md')}</ToggleGroupItem>

      <ToggleGroupItem value="FR">{getWeekdayName(4, 'md')}</ToggleGroupItem>

      <ToggleGroupItem value="SA">{getWeekdayName(5, 'md')}</ToggleGroupItem>

      <ToggleGroupItem value="SU">{getWeekdayName(6, 'md')}</ToggleGroupItem>
    </ToggleGroup>
  )
}
